import TermsAndConditionsView from 'scripts/defa/terms-and-conditions/view-terms-and-conditons-view';
import TermsAndConditionsController from 'scripts/defa/terms-and-conditions/controller-terms-and-conditions-controller';
import TermsAndConditionsRouter     from 'scripts/defa/terms-and-conditions/router-terms-and-conditions-router';
import Module                 from 'scripts/module';

const TermsAndConditionsModule = new Module( 'TermsAndConditionsModule', {
	controllers: {
		TermsAndConditionsController
	},
	routers    : {
		TermsAndConditionsRouter
	},
	views      : {
		TermsAndConditionsView,
	}
} );

export default TermsAndConditionsModule;